import { SagaIterator } from '@redux-saga/core';
import { all, takeLatest, put, call } from 'redux-saga/effects';

import { statusMessageSaga } from 'pages/AppManagement/saga';
import { RequestSagaParams } from 'types';

import * as Actions from './slice';
import * as Endpoints from './endpoints';
import messages from './messages';

export function* getChannelList({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.getChannelsByMarketer, payload);
    yield put(Actions.fetchChannelListSuccess(response.data));
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchChannelListFailure(error));
  }
}

export function* postUploadChannel({ payload }: RequestSagaParams): SagaIterator {
  try {
    yield call(Endpoints.postChannelContent, payload.data);
    yield put(Actions.fetchChannelList({ marketerId: payload.data.marketer }));
    if (payload.callBack) {
      yield call(payload.callBack);
    }
    yield put(Actions.postChannelContentSuccess());
    yield call(statusMessageSaga, { type: 'success', message: messages.create.success });
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.postChannelContentFailure(error));
  }
}

export function* putGenerateClientId({ payload }: RequestSagaParams): SagaIterator {
  try {
    yield call(Endpoints.putGenerateClientId, payload.data);
    yield put(
      Actions.fetchChannelList({
        marketerId: payload.data.marketerId,
        size: payload.data.size,
        page: payload.data.page
      })
    );
    if (payload.callBack) {
      yield call(payload.callBack);
    }
    yield put(Actions.putGenerateClientIdSuccess());
    yield call(statusMessageSaga, { type: 'success', message: messages.generate.success });
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.putGenerateClientIdFailure(error));
  }
}

export function* putUpdateChannelDomains({ payload }: RequestSagaParams): SagaIterator {
  try {
    yield call(Endpoints.putUpdateChannelDomains, payload.data);
    yield put(
      Actions.fetchChannelList({
        marketerId: payload.data.marketerId,
        size: payload.data.size,
        page: payload.data.page
      })
    );
    if (payload.callBack) {
      yield call(payload.callBack);
    }
    yield put(Actions.putGenerateClientIdSuccess());
    yield call(statusMessageSaga, { type: 'success', message: messages.update.success });
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.putGenerateClientIdFailure(error));
  }
}

export function* InfraManagementWatcherSaga(): SagaIterator {
  yield all([
    yield takeLatest(Actions.fetchChannelList.type, getChannelList),
    yield takeLatest(Actions.postChannelContent.type, postUploadChannel),
    yield takeLatest(Actions.putGenerateClientId.type, putGenerateClientId),
    yield takeLatest(Actions.putUpdateChannelDomains.type, putUpdateChannelDomains)
  ]);
}

export default InfraManagementWatcherSaga;
